import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuth} from '../contexts/AuthContext';
import {Role} from '../utils/roles';
import {LoadingSpinner} from './UI/LoadingSpinner';

// Chặn route: yêu cầu đã đăng nhập Google + có vai trò hợp lệ
export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const {isAuthenticated, loading} = useAuth();
    const location = useLocation();

    if (loading) {
        return <LoadingSpinner message="Đang kiểm tra đăng nhập..."/>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/" state={{from: location}} replace/>;
    }

    return <>{children}</>;
};

// Chặn theo vai trò cụ thể (vd: chỉ Admin mới vào Cài đặt / Phân quyền)
export const RoleGuard: React.FC<{ allow: Role[]; children: React.ReactNode }> = ({allow, children}) => {
    const {role, loading} = useAuth();

    if (loading) {
        return <LoadingSpinner message="Đang kiểm tra quyền..."/>;
    }

    if (!role || !allow.includes(role)) {
        if (role === 'tenant') {
            return <Navigate to="/phong-cua-toi" replace/>;
        }
        return <Navigate to="/diennuoc" replace/>;
    }

    return <>{children}</>;
};
